import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  OnInit,
  inject,
  DestroyRef,
  input,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AbstractControl } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { combineLatest, debounceTime } from 'rxjs';

@Component({
  selector: 'dps-field-validation-errors',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './field-validation-errors.component.html',
  styleUrl: './field-validation-errors.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldValidationErrorsComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  private cd = inject(ChangeDetectorRef);

  readonly control = input.required<AbstractControl>();

  @HostBinding('class.hidden') get isHidden(): boolean {
    const control = this.control();
    return control.untouched || control.valid;
  }

  ngOnInit(): void {
    combineLatest([this.control().statusChanges, this.control().valueChanges])
      .pipe(debounceTime(200), takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.cd.markForCheck());
  }
}
